import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const ToolbarDetachCommentIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={32}
        height={32}
        viewBox="0 0 32 32"
        className="Icon toolbar-detach-comment"
        {...props}
    >
        <g fill="none" fillRule="evenodd">
            <rect width={32} height={32} fill="#1B2536" rx={4} />
            <path
                fill="#48505E"
                fillRule="nonzero"
                d="M8 9.25a2.75 2.75 0 0 1 2.402 4.09L12 14.94l5.47-5.47a.75.75 0 0 1 1.06 1.061l-8.128 8.13A2.75 2.75 0 1 1 9.341 17.6l1.597-1.6-1.598-1.598A2.75 2.75 0 1 1 8 9.25zm7.33 9.02 3.2 3.2a.75.75 0 0 1-1.06 1.06l-3.2-3.2a.75.75 0 0 1 1.06-1.06zM8 18.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5zm12-3.5a.75.75 0 1 1 0 1.5h-2a.75.75 0 1 1 0-1.5h2zm-12-4.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5zm18 4.5a.75.75 0 1 1 0 1.5h-2a.75.75 0 1 1 0-1.5h2z"
            />
        </g>
    </svg>
);
const Memo = memo(ToolbarDetachCommentIcon);
export default Memo;
